<template>
    <div class="orgin">
        <div class="title-container">组织管理</div>
        <div class="search-container">
            <el-form ref="form" :model="queryParams" @submit.native.prevent>
                <el-form-item >
                    <el-input v-model="queryParams.username" @keypress.native.enter="search" placeholder="输入名称"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary" @click="search">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="orgin-container">
            <div class="mg-bottom16">
                <el-button type="primary" size="small" @click="openOrgin()">新增组织</el-button>
            </div>
            <div class="table-container">
                <el-table :data="tableData" border v-loading="listLoading">
                    <el-table-column prop="id" label="组织ID" min-width="80"></el-table-column>
                    <el-table-column prop="username" label="名称" min-width="160"></el-table-column>
                    <el-table-column label="手机号码" min-width="140">
                        <template slot-scope="scope">
                            <span v-if="scope.$index === currentIndex">{{scope.row.mobile}}</span>
                            <span v-else>{{scope.row.hideMobile}}</span>
                            <i class="iconfont mg-left8 look-phone" :class="scope.$index === currentIndex ? 'icon-icon_bukejian' : 'icon-icon_kejian'" @click="lookPhone(scope.$index)"></i>
                        </template>
                    </el-table-column>
                    <el-table-column prop="email" label="邮箱" min-width="200"></el-table-column>
                    <el-table-column label="是否启用" min-width="90">
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.is_enabled"
                                :active-value="1"
                                :inactive-value="0"
                                @change="isEnabled(scope.row)">
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="220" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="medium" @click="orginAuthorize(scope.row.id)">授权</el-button>
                            <el-button type="text" size="medium" @click="openOrgin(scope.row.id)">编辑</el-button>
                            <el-button type="text" size="medium" class="danger" @click="delOrgin(scope.row)">删除</el-button>
                            <el-button type="text" size="medium" @click="goApplication(scope.row)">应用管理</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-container text-align-right">
                <Pagination v-bind:child-msg="pageParams" @pageChange="pageChange" />
            </div>
        </div>
        <div v-if="orginDialog">
            <el-dialog :title="dialogTitle" :visible.sync="orginDialog" width="580px" >
                <div class="orginForm-content">
                    <el-form :model="orginForm" :rules="orginRule" ref="orginForm" label-width="85px" label-position="left" >
                        <el-form-item label="名称：" prop="username" >
                            <el-input v-model="orginForm.username" placeholder="请输入名称"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号码：" prop="mobile" >
                            <el-input v-model="orginForm.mobile" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱：" prop="email" >
                            <el-input v-model="orginForm.email" placeholder="请输入邮箱"></el-input>
                        </el-form-item>
                        <el-form-item label="设置密码：" prop="password" v-if="!orginId">
                            <el-input v-model="orginForm.password" placeholder="请输入密码"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码：" prop="repassword" v-if="!orginId">
                            <el-input v-model="orginForm.repassword" placeholder="请再次输入密码"></el-input>
                        </el-form-item>
                        <el-form-item label="站点名称：" >
                            <el-input v-model="orginForm.website_name" placeholder="请输入站点名称"></el-input>
                        </el-form-item>
                        <el-form-item label="站点地址：" >
                            <el-input v-model="orginForm.website_url" placeholder="请输入站点地址"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="orginDialog = false" >取 消</el-button>
                    <el-button type="primary" :loading="loading" size="small" @click="handleOrgin">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <div v-if="authorizeDialog">
            <el-dialog :title="dialogTitle" :visible.sync="authorizeDialog" width="800px" >
                <div class="orginForm-content">
                    <el-form :model="authorizeForm" >
                        <el-form-item >
                            <el-checkbox-group v-model="authorizeForm.resource_ids">
                                <el-checkbox border v-for="(item, index) of resourceList" :key="index" :label="item.id">{{ item.name }}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="authorizeDialog = false" >取 消</el-button>
                    <el-button type="primary" :loading="loading" size="small" @click="handleAuthorize">保 存</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { getOrgin, addOrgin, editOrgin, delOrgin, detailOrgin, handleAuthorize, getResources, isEnabled } from '@/api/orgin/index'
import Pagination from '@/components/Pagination'

export default {
    inject: ['reload'],
    name: 'orgin',
    data() {
        const validatePass = (rule, value, callback) => {
            if (value !== this.orginForm.password) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        const phoneRules = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入手机号码'))
            } else {
                const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/
                if (reg.test(value)) {
                    callback()
                } else {
                    return callback(new Error('请输入正确的手机号码'))
                }
            }
        }
        return {
            listLoading: false,
            loading: false,
            queryParams: {
                page: 1,
                per_page: 10
            },
            pageParams: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            tableData: [],
            orginId: '',
            dialogTitle: '',
            orginDialog: false,
            orginForm: {},
            orginRule: {
                username: [
                    { required: true, message: '名称不能为空', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, validator: phoneRules, trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                repassword: [
                    { required: true, message: '请输入确认密码', trigger: 'blur' },
                    { validator: validatePass, trigger: 'blur' }
                ]
            },
            currentIndex: '',
            authorizeDialog: false,
            resourceList: [],
            authorizeForm: {
                resource_ids: []
            }
        }
    },
    components: {
        Pagination
    },
    created() {
        this.getOrgin()
        this.getResources()
    },
    methods: {
        getOrgin() {
            this.listLoading = true
            this.queryParams.page = this.pageParams.currentPage
            this.queryParams.per_page = this.pageParams.pageSize
            getOrgin(this.queryParams).then(res => {
                if (res.code === 0) {
                    var reg = /^(\d{3})\d{4}(\d{4})$/
                    let orginList = res.data.list
                    orginList.forEach(item => {
                        let hideMobile = item.mobile
                        hideMobile = hideMobile.replace(reg, '$1****$2')
                        item.hideMobile = hideMobile
                    })
                    this.tableData = orginList
                    this.pageParams.total = res.data.total
                }
                this.listLoading = false
            }).catch((res) => {
                this.listLoading = false
            })
        },
        openOrgin(id) {
            this.orginId = id
            if (this.orginId !== undefined) {
                this.dialogTitle = '编辑组织'
                detailOrgin(this.orginId).then(res => {
                    if (res.code === 0) {
                        this.orginForm = res.data
                        this.orginDialog = true
                    }
                }).catch(res => {})
            } else {
                this.dialogTitle = '新增组织'
                this.orginForm = {}
                this.orginDialog = true
            }
        },
        handleOrgin() {
            this.$refs['orginForm'].validate((valid) => {
                if (valid) {
                    this.loading = true
                    if (this.orginId !== undefined) {
                        editOrgin(this.orginForm, this.orginId).then(res => {
                            this.loading = false
                            if (res.code === 0) {
                                this.$message.success(res.msg)
                                this.reload()
                            }
                        }).catch(res => {
                            this.loading = false
                        })
                    } else {
                        addOrgin(this.orginForm).then(res => {
                            this.loading = false
                            if (res.code === 0) {
                                this.$message.success(res.msg)
                                this.reload()
                            }
                        }).catch(res => {
                            this.loading = false
                        })
                    }
                }
            })
        },
        lookPhone(index) {
            if (this.currentIndex === index) {
                this.currentIndex = ''
            } else {
                this.currentIndex = index
            }
        },
        orginAuthorize(id) {
            this.orginId = id
            this.dialogTitle = '授权'
            detailOrgin(this.orginId).then(res => {
                if (res.code === 0) {
                    let resources = res.data.resources
                    this.authorizeForm.resource_ids = resources.map(item => item.id)
                    this.authorizeDialog = true
                }
            }).catch(res => {})
        },
        handleAuthorize() {
            if (this.authorizeForm.resource_ids.length == 0) {
                this.$message.error('最少选择一个资源！')
            } else {
                this.loading = true
                handleAuthorize(this.authorizeForm, this.orginId).then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.$message.success(res.msg)
                        this.reload()
                    }
                }).catch(res => {
                    this.loading = false
                })
            }
        },
        delOrgin(row) {
            this.$confirm('确定删除' + row.username + '吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true
                delOrgin(row.id).then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.$message.success(res.msg)
                        this.reload()
                    }
                }).catch(res => {
                    this.loading = false
                })
            })
        },
        isEnabled(row) {
            isEnabled({ status: row.is_enabled }, row.id).then(res => {
                if (res.code === 0) {
                    this.$message.success(res.msg)
                }
            })
        },
        search() {
            this.queryParams.page = 1
            this.pageParams.currentPage = 1
            this.getOrgin()
        },
        // 分页
        pageChange(page) {
            this.pageParams.currentPage = page.currentPage
            this.pageParams.pageSize = page.pageSize
            this.getOrgin()
        },
        getResources() {
            getResources().then(res => {
                if (res.code === 0) {
                    this.resourceList = res.data.list
                }
            }).catch((res) => {})
        },
        goApplication(row) {
            this.$router.push({
                path: '/orgin/application',
                query: { oid: row.id }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.look-phone{
    color: $primaryColor;
    font-size: 12px;
    cursor: pointer;
}
.orginForm-content{
    .el-form-item:last-child{
        margin-bottom: 0;
    }
    .el-checkbox-group{
        margin-bottom: -16px;
        .el-checkbox.is-bordered{
            vertical-align: top;
            margin-bottom: 16px;
            width: 240px;
            margin-left: 0;
            margin-right: 16px;
            &:nth-child(3n){
                margin-right: 0;
            }
        }
    }
}
</style>
